import { RouteObject } from "react-router-dom";
import { lazy } from "react";

const HomePage = lazy(() => import("../pages/home/page"));
const AboutPage = lazy(() => import("../pages/about/page"));
const TreatmentsPage = lazy(() => import("../pages/treatments/page"));
const ProductsPage = lazy(() => import("../pages/products/page"));
const ContactPage = lazy(() => import("../pages/contact/page"));
const PrivacyPage = lazy(() => import("../pages/privacy/page"));
const TermsPage = lazy(() => import("../pages/terms/page"));
const DisclaimerPage = lazy(() => import("../pages/disclaimer/page"));
const RefundPage = lazy(() => import("../pages/refund/page"));
const NotFoundPage = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/treatments",
    element: <TreatmentsPage />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "/disclaimer",
    element: <DisclaimerPage />,
  },
  {
    path: "/refund",
    element: <RefundPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;
